import React from "react";
import { Route, Routes } from "react-router-dom";
import AttendeeLayout from "components/layouts/attendee-layout";
import AttendeeHome from "containers/attendee/home";
import ParentGuardianDetails from "containers/attendee/parent-guardian-details";
import FamilyInformation from "containers/attendee/family-information";
import DeclarationForm from "containers/attendee/declaration";
import AttendeExperiences from "containers/attendee/experiences";
import AttendeeEditProfile from "containers/attendee/edit-profile";
import AttendeeCommunities from "containers/attendee/communities";
import FamilyMembers from "containers/attendee/family-members";
import AttendeeGeneralSettings from "containers/attendee/general-setting";
import ExperiencesDetail from "containers/attendee/experience-details";
import Ratings from "containers/attendee/experience-details/component/Ratings";
import SignedUpExperience from "containers/attendee/signed-up-experience";
import AttendeeJoining from "containers/attendee/joining";
import HostProfileDetail from "containers/attendee/host-profile-details";
import FamilyDetail from "containers/attendee/family-details";
import AttendeePasses from "containers/attendee/view-passes";
import AttendeeResourceLibrary from "containers/attendee/resource-library";
import FavouriteHosts from "containers/attendee/favorite-hosts";
import AttendeeJoinAndPay from "containers/attendee/joining/component";
import LearningStyleQuestions from "containers/attendee/family-details/component/LearningStyleQuestions";
import LearningSkills from "containers/attendee/family-details/component/LearningSkills";
import AttendeeExperiencesDetail from "containers/attendee/experience-details";

const AttendeRoutes = () => {
  return (
    <AttendeeLayout>
      <Routes>
        <Route path="/home" element={<AttendeeHome />} />
        <Route
          path="/parent-guardian-details"
          element={<ParentGuardianDetails />}
        />
        <Route path="/family-information" element={<FamilyInformation />} />
        <Route path="/declaration-form" element={<DeclarationForm />} />
        <Route path="/experiences" element={<AttendeExperiences />} />
        <Route path="/experiences-detail" element={<AttendeeExperiencesDetail />} />
        <Route path="/ratings" element={<Ratings />} />
        <Route path="/signed-experience" element={<SignedUpExperience />} />
        <Route path="/joining" element={<AttendeeJoining />} />
        <Route path="/join-and-pay" element={<AttendeeJoinAndPay />} />
        <Route path="/passes" element={<AttendeePasses />} />
        <Route path="/favorite-hosts" element={<FavouriteHosts />} />
        <Route path="/edit-profile" element={<AttendeeEditProfile />} />
        <Route path="/general-settings" element={<AttendeeGeneralSettings />} />
        <Route path="/communities" element={<AttendeeCommunities />} />
        <Route path="/family-members" element={<FamilyMembers />} />
        <Route path="/host-profile-detail" element={<HostProfileDetail />} />
        <Route path="/family-detail" element={<FamilyDetail />} />
        <Route path="/resource-library" element={<AttendeeResourceLibrary />} />
        <Route path="/family-detail/assessment/learning-style" element={<LearningStyleQuestions />} />
        <Route path="/family-detail/assessment/learning-skills" element={<LearningSkills />} />




        
      </Routes>
    </AttendeeLayout>
  );
};

export default AttendeRoutes;
